import Vue from 'vue'
import Router from 'vue-router'
import Default from "@/Default";

Vue.use(Router);
const base = require("./config/webzine.config.json")[process.env.NODE_ENV].ROUTER_BASE;

const router = new Router({
    mode: 'history',
    base: base,
    routes: [
        {
            path: '',
            component: Default
        },
        {
            path: '/publish/all',
            component: () => import('./views/WebZineListMain')
        },
        {
            path: '/:mode/:webzine_id',
            component: () => import('./views/WebZineViewMain'),
            children: [
                {
                    path: '',
                    components: {
                        toc: () => import('./components/WebZineViewToc'),
                        content: () => import('./components/WebZineViewArticleList')
                    },
                }
            ]
        },
        {
            path: '/:mode/:webzine_id/articles/:article_id',
            component: () => import('./views/WebZineArticleMain'),
            children: [
                {
                    path: '',
                    components: {
                        toc: () => import('./components/ArticleViewToc'),
                        content: () => import('./components/ArticleView')
                    },
                }
            ]
        }
        // {
        //     path: '/:mode/:webzine_id',
        //     component: () => import('./views/WebZineViewMain'),
        //     children: [
        //         {
        //             path: '',
        //             components: {
        //                 toc: () => import('./components/WebZineViewToc'),
        //                 content: () => import('./components/WebZineViewArticleList')
        //             },
        //         }, {
        //             path: 'articles/:article_id',
        //             components: {
        //                 toc: () => import('./components/ArticleViewToc'),
        //                 content: () => import('./components/ArticleView')
        //             },
        //         }
        //     ]
        // }

    ]
});



export default router
